<template>
  <div class="modal-box">
    <div class="loading-box" v-if="isLoading">
      <loading></loading>
    </div>
    <div class="modal block-modal" @click.self="$emit('close-btn-click')">
      <div class="modal-dialog">
        <div v-show ="!isApiComplete">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">{{ audience.name }} さんを通報する</h4>
            </div>
            <div class="modal-body">
              <div class="exclamation_img_box">
                <img class="exclamation_img" :src="exclamation_img_path"/>
              </div>
              <div class="action-box">
                <div class="checkbox-box">
                  <input type="checkbox" id="is_block" class="hogehoge" v-model="isBlock" :checked="isBlock"/>
                  <label for="is_block">この参加者を申込制限する</label>
                </div>
                <p>今後、あなたのイベントに申込できなくなります。</p>
              </div>
              <div class="checkbox-box">
                <input type="checkbox" id="is_cancel" class="hogehoge" v-model="isCancel"/>
                <label for="is_cancel">この参加者の申込をキャンセルする</label>
              </div>
              <p>この参加者の申込をすべてキャンセルできます。</p>
              <p>事前購入で払い戻し可能なものについては払い戻し処理されます。</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn btn-primary" @click="block">通報</button>
              <button type="button" class="btn btn-warning" @click="$emit('close-btn-click')">閉じる</button>
            </div>
          </div>
        </div>
        <transition key='isApiComplete-modal' appear>
          <div v-show ="isApiComplete" key='isApiComplete-modal2'>
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ audience.name }} さんを通報しました</h4>
              </div>
              <div class="modal-body">
                <div class="exclamation_img_box">
                  <img class="exclamation_img" :src="comment_img_path"/>
                </div>
                <p class="center-lbl">通報いただき、ありがとうございました。</p>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn btn-primary" @click="$emit('close-btn-click')">閉じる</button>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import consts from '../utils/consts';

export default {
  props: {
    audience: { type: Object, required: true },
    exclamation_img_path: { type: String, required: true },
    comment_img_path: { type: String, required: true },
    block_audience_path: { type: String, required: true },
    main_event_id: { type: Number, required: true },
  },
  data() {
    return {
      isBlock: false,
      isCancel: false,
      isLoading: false,
      isApiComplete: false,
    };
  },
  created() {
  },
  methods: {
    async block() {
      this.isLoading = true;
      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      const all_cancel = this.isCancel ? consts.ALL_CANCEL.YES : consts.ALL_CANCEL.NO;
      const punish_type = this.isBlock ? consts.PUNISH_TYPE.BLOCK : consts.PUNISH_TYPE.NON_BLOCK;
      let has_erro = false;
      const data = {
        to_id: this.audience.owner_id,
        event_id: this.main_event_id,
        all_cancel: all_cancel,
        to_mail: this.audience.email,
        punish_type: punish_type,
      };
      await this.$store.dispatch('audience/blockAudience', { block_audience_path: this.block_audience_path, data: data, csrf_token: csrfToken, owner_id: this.audience.owner_id, audience_id: this.audience.id }).catch((err) => {
        alert('エラーが発生しました。時間をおいてから改めてお試しください。');
        has_erro = true;
      });
      this.isLoading = false;
      if (has_erro == false) this.isApiComplete = true;
    },
  },
  watch: {
    isBlock: function (newVal) {
      if (newVal) {
        const msg = '今後、この参加者はあなたが主催するイベントの購入・予約ができなくなります。本当によろしいですか？';
        const confirmed = confirm(msg);
        this.isBlock = confirmed;
        // v-modelの値とチェックの値が一致しないので直接書き換え。ベストな方法ではない...。
        document.getElementById('is_block').checked = confirmed;
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import 'app/assets/stylesheets/foundation/variable/color.scss';
$break-point: 768px;

.modal-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: $translucent-black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9998;

  .block-modal {
    display: flex;
    overflow-y: auto;

    .modal-title {
      font-size: 18px;
    }

    .modal-dialog {
      max-width: 100%;
      width: 700px;
      margin: auto;

      @media screen and (max-width: $break-point) {
        margin: auto 30px;
        height: 550px;
      }
    }

    .modal-body {
      padding: 15px;
      line-height: 1.5em;
      margin-bottom: 15px;

      label {
        font-weight: 500;
        vertical-align: middle;
        margin-bottom: 10px;
      }

      .exclamation_img_box {
        text-align: center;

        .exclamation_img {
          height: 150px;
          margin-top: 10px;
          margin-bottom: 20px;
        }
      }
      .action-box {
        padding-top: 10px;
        padding-bottom: 10px;
        margin-bottom: 15px;
      }

      .center-lbl {
        text-align: center;
      }
    }

    .modal-content {
      box-shadow: none;
      z-index: 9997;
    }

    .modal-footer {
      flex-direction: column;
      margin: auto;
    }
  }

  .loading-box {
    background-color: #000;
    opacity: 0.8;
    z-index: 1051;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;

    .pg-performer-events--loader {
      position: fixed;
      top: 25%;
      left: 50%;
      z-index: 9999;
    }
  }

  // アニメーション
  .v-leave-active,
  .v-enter-active {
    transition: opacity 0.5s;
  }
  .v-enter {
    opacity: 0;
  }
  .v-enter-to {
    opacity: 1;
  }
  .v-leave {
    opacity: 1;
  }
  .v-leave-to {
    opacity: 0;
  }
}
</style>